import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { canAccess } from "@/lib/plans";

export const SCORE_LABELS = { tesm: "TESM", bnbd: "BNBD", pcei: "PCEI", pcab: "PCAB", prebid: "Pre-Bid", tapi: "TAPI" };
const FEATURE = { tesm: "tesm", bnbd: "bnbd", pcei: "pcei", pcab: "pcab", prebid: "pcei", tapi: "tapi" };
const GOOD = "border-good/40 bg-good-soft text-good";
const WARN = "border-warn/40 bg-warn-soft text-warn";
const NEUTRAL = "border-ink-line bg-secondary text-ink-muted";
const TONE = { dark_green: GOOD, green: GOOD, good: GOOD, amber: WARN, orange: WARN, red: WARN, warn: WARN };

// Which score cards a plan sees on each Tender List tab.
export function scoreColumns(user, tab) {
  const eff = user?.role === "admin" ? "professional" : user?.plan_info?.effective_plan;
  const pro = eff === "professional" || eff === "enterprise";
  const base = pro ? ["bnbd", "pcei", "pcab", "prebid"] : eff === "growth" ? ["tesm", "bnbd"] : ["tesm"];
  if (tab === "submitted") return pro ? ["tapi"] : [...base, "tapi"];
  if (tab === "closed") return [...base, "tapi"];
  return base;
}

export default function ScoreCardCell({ tender, kind, card, user }) {
  const testid = `score-${kind}-${tender.id}`;
  if (!canAccess(user, FEATURE[kind])) {
    return (
      <Link to="/plans" data-testid={`${testid}-locked`} title={`Upgrade to unlock ${SCORE_LABELS[kind]}`}
        className="inline-flex items-center gap-1 text-[11px] text-ink-muted hover:text-brand whitespace-nowrap">
        <Lock className="w-3 h-3" /> Upgrade
      </Link>
    );
  }
  const tab = kind === "prebid" ? "overview" : kind;
  if (!card) {
    return (
      <Link to={`/tenders/${tender.id}?tab=${tab}`} data-testid={`${testid}-run`}
        className="text-[12px] text-brand hover:text-brand-hover whitespace-nowrap">
        {kind === "prebid" ? "—" : `+ Run ${SCORE_LABELS[kind]}`}
      </Link>
    );
  }
  return (
    <Link to={`/tenders/${tender.id}?tab=${tab}`} data-testid={testid} title={`${SCORE_LABELS[kind]} · ${card.band || ""}`}
      className={`chip whitespace-nowrap ${TONE[card.color || card.tone] || NEUTRAL}`}>
      <span className="font-num font-bold mr-1">{card.score}</span>{(card.band || "").replace(" risk", "")}
    </Link>
  );
}
